import { find } from 'lodash-es';
import { FormStatus } from '../../state/interfaces';
import { IDemographicExtensions } from './biographics.model';


export class Pending implements PendingResponse {
  lithocode: string;
  sessionId: string;
  sortKey: string;
  firstName: string;
  lastName: string;
  stateStudentId: string;
  birthDate: string;
  gender: string;
  genderValidValues?: string[];
  tstTestDate?: string;
  readingTestDate?: string;
  mathTestDate?: string;
  languageTestDate?: string;
  speakingTestDate?: string;
  listeningTestDate?: string;
  writingTestDate?: string;
  tstFormSpecifier?: string;
  tstLevelSpecifier?: string;
  rdFormSpecifier?: string;
  rdLevelSpecifier?: string;
  laFormSpecifier?: string;
  laLevelSpecifier?: string;
  mdFormSpecifier?: string;
  mdLevelSpecifier?: string;
  liFormSpecifier?: string;
  liLevelSpecifier?: string;
  wrFormSpecifier?: string;
  wrLevelSpecifier?: string;
  spFormSpecifier?: string;
  spLevelSpecifier?: string;
  formSpecifierValidValues?: string[];
  levelSpecifierValidValues?: string[];
  testParts: {[subject: string]: {attempted?: boolean, formSpecifier?: string, levelSpecifier?: string, testDate?: string}} = {READING: {}, MATH: {}, LANGUAGE: {}, SPEAKING: {}, LISTENING: {}, WRITING: {}};
  form: string;
  scoringStatus?: string;
  scanIds?: string[];
  alerts?: AlertItem[];
  formEditVersion?: number;
  formStatus?: FormStatus;
  extensions?: IDemographicExtensions[];

  constructor(pending: PendingResponse) {
    Object.assign(this, pending);
    if (!this.genderValidValues) {
      this.genderValidValues = Array.from(GENDER_MAP.keys());
    }
  }

  canSubmit(): boolean {
    return !this.hasBiographicError() && !this.hasScoreInputError();
  }

  hasBiographicError(): boolean {
    return !!find(this.alerts, {alertType: 'biographic'});
  }

  hasScoreInputError(): boolean {
    return !!find(this.alerts, {alertType: 'scoreInput'});
  }

  hasAlerts(): boolean {
    return !!(this.alerts && this.alerts.length);
  }

  hasAlertOfType(type: AlertType): boolean {
    if (!this.alerts) {
      return false;
    }
    return !!this.alerts.find(alerts => alerts.alertType === type);
  }

  clearBiographicAlerts() {
    if (!this.alerts) {
      return;
    }
    this.alerts = this.alerts.filter(alert => alert.alertType !== 'biographic');
  }
}

export interface PendingResponse {
  lithocode: string;
  sessionId: string;
  sortKey: string;
  firstName: string;
  lastName: string;
  stateStudentId: string;
  birthDate: string;
  gender: string;
  genderValidValues?: string[];
  tstTestDate?: string;
  readingTestDate?: string;
  mathTestDate?: string;
  languageTestDate?: string;
  speakingTestDate?: string;
  listeningTestDate?: string;
  writingTestDate?: string;
  tstFormSpecifier?: string;
  tstLevelSpecifier?: string;
  rdFormSpecifier?: string;
  rdLevelSpecifier?: string;
  laFormSpecifier?: string;
  laLevelSpecifier?: string;
  mdFormSpecifier?: string;
  mdLevelSpecifier?: string;
  liFormSpecifier?: string;
  liLevelSpecifier?: string;
  wrFormSpecifier?: string;
  wrLevelSpecifier?: string;
  spFormSpecifier?: string;
  spLevelSpecifier?: string;
  formSpecifierValidValues?: string[];
  levelSpecifierValidValues?: string[];
  testParts: {[subject: string]: {attempted?: boolean, testDate?: string}};
  form: string;
  scoringStatus?: string;
  scanIds?: string[];
  alerts?: AlertItem[];
  formEditVersion?: number;
  formStatus?: FormStatus;
  extensions?: IDemographicExtensions[];
}

export interface PendingWithAlerts extends Pending {
  alerts: AlertItem[];
}

export const GENDER_MAP = new Map([
  ['M', 'Male'],
  ['F', 'Female'],
  ['O', 'Other'],
  ['N', 'Non-binary'],
  ['P', 'Prefer not to answer']
]);

export type AlertType = 'blank' | 'multi' | 'scoreInput' | 'submit' | 'biographic' | 'submittedAwaitingResponse';

export class AlertItem {
  scanId: string;
  pageId: string;
  question: string;
  alertType: AlertType;
  materialId: string;
  childSpecifier?: string;

  constructor(alertType: AlertType, humanReadableId: string, materialId: string, scanId: string, pageId: string, childSpecifier: string = null) {
    this.question = humanReadableId;
    this.materialId = materialId;
    this.alertType = alertType;
    this.scanId = scanId;
    this.pageId = pageId;
    this.childSpecifier = childSpecifier;
  }
}
